import { Extension } from '@tiptap/core'

type ColorOptions = {
  types: string[]
}

/* eslint-disable unicorn/consistent-function-scoping, import/prefer-default-export */

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    color: {
      setFontColor: (fontColor: string) => ReturnType
      unsetFontColor: () => ReturnType
    }
  }
}

export const Color = Extension.create<ColorOptions>({
  name: 'color',

  addOptions() {
    return {
      types: ['customTextStyle'],
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            renderHTML: (attributes) => {
              if (!attributes.color) {
                return {}
              }

              return {
                style: `color: ${attributes.color}`,
              }
            },
            parseHTML: (element) => ({
              color: element.style.color,
            }),
          },
        },
      },
    ]
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  addCommands() {
    return {
      setFontColor:
        (value) =>
        ({ commands }) => {
          return commands.setTextStyle(this.name, value)
        },
      unsetFontColor:
        () =>
        ({ commands }) => {
          return commands.unsetTextStyle(this.name)
        },
    }
  },
})
